export enum ItemWorkflowFileType {
	GDOC = "GDoc",
	GSHEET = "GSheet",
	GSLIDE = "GSlide"
}
